import {
  Component,
  Input,
  OnChanges,
  OnDestroy,
  SimpleChanges,
} from '@angular/core';
import { Subject, takeUntil } from 'rxjs';
import { DealerPageListingConfig } from '@core/tenant/dealer-site.model';
import { DealerDataService } from '../../dealer-data.service';

@Component({
  selector: 'ade-listing',
  templateUrl: './listing.component.html',
  styleUrls: ['./listing.component.scss'],
})
export class AdeListingComponent implements OnChanges, OnDestroy {
  @Input() config: DealerPageListingConfig;
  @Input() title: string;
  @Input() subtitle: string;
  @Input() widgets: any[] = [];

  vehicles: any[] = [];
  isLoading = true;
  page = 1;
  pageCount = 1;

  private _unsub = new Subject<void>();

  constructor(private _svc: DealerDataService) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['config'] && this.config) {
      this.page = 1;
      this._load();
    }
  }

  goToPage(page: number): void {
    if (page < 1 || page > this.pageCount || page === this.page) return;
    this.page = page;
    this._load();
  }

  private _load(): void {
    this.isLoading = true;
    this.vehicles = [];
    this._unsub.next();

    this._svc
      .getProductsFromConfig(this.config, this.page)
      .pipe(takeUntil(this._unsub))
      .subscribe({
        next: (r: any) => {
          this.vehicles = r?.data || [];
          this.pageCount = r?.meta?.pagination?.pageCount ?? 1;
          this.isLoading = false;
        },
        error: () => {
          this.isLoading = false;
        },
      });
  }

  get columns(): number {
    return this.config?.product_columns ?? 3;
  }

  ngOnDestroy(): void {
    this._unsub.next();
    this._unsub.complete();
  }
}
